<template>
  <div>
    <div>
      <span class="xbed-sub-title">推广码管理</span>
    </div>

    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>微信</BreadcrumbItem>
        <BreadcrumbItem>推广码管理</BreadcrumbItem>
      </Breadcrumb>

    </div>

    <section style="margin-top:20px">
        <Form @submit.native.prevent="preventSubmit" inline>
            <FormItem prop="cmsName" label="推广人员：" :label-width="84">
                <Input type="text" v-model="queryParams.cmsName" :maxlength="100"></Input>
            </FormItem>
            <FormItem label="渠道：" prop="sourcesName" :label-width="120">
                <Select ref="queryParamsources" v-model="queryParams.sourcesName" clearable filterable>
                    <Option v-for="item in wayTypeSelect" :key="item.scId" :value="item.scId">{{item.sources}}</Option>
                </Select>
            </FormItem>
            <FormItem label="省份：" prop="province" :label-width="120">
                <Select ref="queryParamsPro" v-model="queryParams.province" @on-change="changeProvice" clearable filterable>
                    <Option v-for="item in provincesList" :key="item.id" :value="item.id">{{item.name}}</Option>
                </Select>
            </FormItem>
            <FormItem label="城市：" prop="city" :label-width="84">
                <Select ref="queryParamsCity" v-model="queryParams.city" clearable filterable>
                    <Option v-for="item in cityList" :key="item.id" :value="item.id">{{item.name}}</Option>
                </Select>
            </FormItem>
            <FormItem style="margin-left:45px;">
                <Button type="primary" @click="queryTariffListWithKeyword">查询</Button>
                <Button type="primary" @click="openEditTariffModal" style="margin-left:10px;">新增推广人员</Button>
            </FormItem>
        </Form>
        <!-- Table-->
        <Table stripe :loading="tariffList.loading" ref="tariffReportTable" :columns="column" :data="tariffList.content"></Table>
        <div style="margin: 10px;overflow: hidden">
            <Page show-sizer placement="top" :total="listCount" :current="listPage" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
        </div>
    </section>

    <!-- Modal -->
    <Modal v-model="editTariffModal.display" :loading="true"  ref="editTariffModal" :title="editTariffModal.disabled?'编辑二维码':'新增二维码'" @on-ok="addModalOk">
      <Form @submit.native.prevent="preventSubmit" :model="editTariffModal" ref="editTariffModalForm" :rules="editTariffModal.rules" :label-width="170">
        <FormItem prop="cmsName" label="推广人员名称(唯一)：">
          <Input type="text" v-model="editTariffModal.cmsName" :disabled="editTariffModal.disabled"></Input>
        </FormItem>
        <FormItem prop="keyword" label="关键词：">
          <Input v-model="editTariffModal.keyword" />
        </FormItem>
        <FormItem prop="provinceId" label="省份：">
            <Select ref="getProSelete" v-model="editTariffModal.provinceId" @on-change="changeProvice" filterable>
                <Option v-for="item in provincesList" :key="item.id" :value="item.id">{{item.name}}</Option>
            </Select>
        </FormItem>
        <FormItem prop="cityId" label="城市：">
            <Select ref="getCitySelete" v-model="editTariffModal.cityId" filterable>
            <Option v-for="item in cityList" :key="item.id" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="sources" label="渠道：" >
          <Select ref="getSource" v-model="editTariffModal.sources" filterable>
            <Option v-for="item in wayTypeSelect" :key="item.scId" :value="item.scId">{{item.sources}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="name" label="报表展示名称：">
          <Input v-model="editTariffModal.name" :disabled="editTariffModal.disabled"/>
        </FormItem>
        <FormItem prop="state" label="是否可用：">
            <RadioGroup v-model="editTariffModal.state">
                <Radio label="1">是</Radio>
                <Radio label="2">否</Radio>
            </RadioGroup>
        </FormItem>
      </Form>
    </Modal>

    <!-- qrcode-->
    <Modal v-model="qrcodeModal.display" ref="qrcodeModal" :title="qrcodeModal.title" :width="600" style="text-align:center;">
      <div style="height: 430px;">
        <img :src="qrcodeModal.rqcodeUrl"/>
      </div>  
      <div slot="footer">
        <Button @click="closeQrcodetModal">关闭</Button>
      </div>
    </Modal>

  </div>
</template>

<script>
import Utils from '../../utils'
import API from "../../api";

export default {
    created() {
      this.token = Utils.findFromLocalStorage("vue-token");
      this.username = Utils.findFromLocalStorage("vue-username");
      this.env = Utils.findFromLocalStorage("env", "dev");
      this.headerENV = Utils.aliHeaderEnv(this.env)
    },
    mounted(){
      this.init()
    },
    data(){
      const editTariffModalRules = {
          cmsName: (rule, value, callback) => {
            if (this.editTariffModal.cmsName.length == 0) {
              return callback(new Error('推广人员名称不能为空'));
            }

            callback();
          },
          keyword:(rule,value,callback) => {
            if(this.editTariffModal.keyword.length == 0){
              return callback(new Error('关键词不能为空'))
            }

            callback();
          },
          provinceId:(rule,value,callback) => {
            if(!this.editTariffModal.provinceId){
              return callback(new Error('省份不能为空'))
            }

            callback();
          },
          cityId:(rule,value,callback) => {
            console.info('this.editTariffModal.cityId----------',this.editTariffModal.cityId)
            if(!this.editTariffModal.cityId){
              return callback(new Error('城市不能为空'))
            }

            callback();
          },
          sources:(rule,value,callback) => {
            if(!this.editTariffModal.sources){
              return callback(new Error('渠道不能为空'))
            }

            callback();
          },
          name:(rule,value,callback) => {
            if(this.editTariffModal.name.length == 0){
              return callback(new Error('报表名称不能为空'))
            }

            callback();
          }

      }
      return {
          queryParams:{
            page:1,
            pageSize:10,
            cmsName:'',
            sourcesName:'',
            province:'',
            city:'',
          },
          sendQueryParams:{
            page:1,
            pageSize:10,
            cmsName:'',
            sourcesName:'',
            province:'',
            city:'',
          },
          qrcodeModal:{
            display:false,
            rqcodeUrl:null,
          },
          listCount:0,
          listPage:1,
          provincesList:[],
          cityList:[],
          cityId:'',
          tariffList:[],
          wayTypeSelect:[],
          editTariffModal:{
              display:false,
              rules:{
                cmsName:[{required:true,trigger: 'blur',
                validator: editTariffModalRules.cmsName }],
                keyword:[{required:true,trigger: 'blur',
                validator: editTariffModalRules.keyword }],
                provinceId:[{required:true,trigger: 'change',
                validator: editTariffModalRules.provinceId }],
                cityId:[{required:true,trigger: 'change',
                validator: editTariffModalRules.cityId }],
                sources:[{required:true,trigger: 'change',
                validator: editTariffModalRules.sources }],
                name:[{required:true,trigger: 'blur',
                validator: editTariffModalRules.name }],
              }

          },
          column: [
          {
            title: "ID",
            key: "qrId",
            align: "center",
            width: 80
          },
          {
            title: "推广人员",
            key: "cmsName",
            align: "center",
            width: 150
          },
          {
            title: "门店ID",
            key: "chainId",
            align: "center",
            width: 150,
            render: (h, params) => {
              return h('span', {}, params.row.chainId ? params.row.chainId : '-')
            }
          },
          {
            title: "报表展示名称",
            key: "name",
            align: "center",
            width: 150
          },
          {
            title: "省份",
            key: "province",
            align: "center",
            width: 150
          },
          {
            title: "城市",
            key: "city",
            align: "center",
            width: 150
          },
          {
            title: "关键词",
            key: "keyword",
            align: "center",
            width: 150
          },
          {
            title: "扫码数(二维码)",
            key: "scanNo",
            align: "center",
            width: 150
          },
          {
            title: "关注数(二维码)",
            key: "subFansNo",
            align: "center",
            width: 150
          },
          {
            title: "注册数(二维码)",
            key: "regFansNo",
            align: "center",
            width: 150
          },
          {
            title: "扫码数(小程序码)",
            key: "miniScanNum",
            align: "center",
            width: 150
          },
          {
            title: "注册数(小程序码)",
            key: "miniRegNum",
            align: "center",
            width: 150
          },
          {
            title: "状态",
            key: "state",
            align: "center",
            width: 150,
            render: (h, params) => {
              let state = params.row.state == 1 ? '是' : '否';
              return h("div", {}, state);
          }
          },
          {
            title: "推广码",
            align: "center",
            width: 300,
            // render: (h, params) => {
            //   return h(
            //     "Button",
            //     {
            //       props:{
            //         type: "primary",
            //         size: "small"
            //       },
            //       on:{
            //         click:() =>{
            //             this.openQrcodeModal(params.row.ticket)
            //         }
            //       }
            //     },
            //     '获取二维码'
            //   )
            // }
            // render: (h, params) => {
            //     return h("Button", {
            //         props: {
            //             type: "primary",
            //             size: "small"
            //         },
            //         on: {
            //             click:() =>{
            //                 this.openQrcodeModal(params.row.ticket)
            //             }
            //         }
            //     }, '获取二维码')
            // }
            render: (h, params) => {
                return h("div", [
                    h("Button", {
                        props: {
                            type: "primary",
                            size: "small"
                        },
                        on: {
                            click:() =>{
                                this.openQrcodeModal(params.row.ticket)
                            }
                        }
                    }, '获取二维码'),
                    h("Button", {
                        props: {
                            type: "primary",
                            size: "small"
                        },
                        style: {
                          marginLeft:'10px',
                        },
                        on: {
                            click:() =>{
                                this.getMiniCode(params.row)
                            }
                        }
                    }, '获取小程序码')
                ])
            }
          },
          {
            title: "渠道",
            key: "sourcesName",
            align: "center",
            width: 150
          },
          {
            title: "操作",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        // TODO: 打开modal
                        // this.openEditTariffModal();
                        this.openEditTariffModal(params.row);
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    style:{
                      marginLeft:'10px',
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "提示",
                          content: `确定删除${params.row.qrId} - ${params.row.cmsName}吗？\n一经确定将无法修改`,
                          okText: "确定删除",
                          cancelText: "取消",
                          onOk: () => {
                            this.delTariff(params.row.qrId)
                          }
                        });
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
      }
  },
  methods:{
      init(){
        this.queryProvincesList()
        this.queryTariff()
        this.getWayTypeSelete()
      },
      async getWayTypeSelete(){
        let wayType = (await API.omsAPI[this.env].wechat.getSources({page:1,pageSize:9999,sourcesName:''},this.token)).data.content
        this.wayTypeSelect = wayType
      },
      openEditTariffModal( tariff = {} ){
        //重置表单
        console.info('this.editTariffModal------------------------------------',this.editTariffModal)
        this.changeProvice(tariff.provinceId).then(_cityList=>{
          Object.assign(this.editTariffModal, {
              display:true,
              disabled:false,
              id: '',
              cmsName:'',
              keyword:'',
              province:'',
              provinceId:null,
              city:'',
              cityId:null,
              sources:null,
              name:'',
              state:'1',
            }, {
              cmsName: tariff.cmsName,
              name: tariff.name,
              keyword: tariff.keyword,
              sources: tariff.sources,
              id: tariff.qrId,
              province: tariff.province,
              provinceId: tariff.provinceId,
              cityId: tariff.cityId,
              city: tariff.city,
              state: tariff.state + '',
              display: true,
              disabled: tariff.qrId ? true : false
            })
          console.info('this.editTariffModalnow------------------------------------',this.editTariffModal,  this.editTariffModal.cityId, _cityList, this.cityList)
        })
      },
      queryTariffListWithKeyword(){
        this.queryParams.cmsName = this.queryParams.cmsName.trim();

        this.sendQueryParams = Object.assign({}, this.queryParams, {
          sourcesName: this.$refs.queryParamsources.query,
          province: this.$refs.queryParamsPro.query,
          city: this.$refs.queryParamsCity.query,
        });
        this.queryTariff()

      },
      openQrcodeModal(ticket){
        this.qrcodeModal.rqcodeUrl = ''
        this.qrcodeModal.display = true
        this.qrcodeModal.title = '二维码'
        this.qrcodeModal.rqcodeUrl = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + ticket
      },
      async getMiniCode (row) {
        this.qrcodeModal.rqcodeUrl = ''
        this.qrcodeModal.display = true
        this.qrcodeModal.title = '小程序码'
        let params = {
            scene: row.cmsName,
            page: row.chainId ? 'pages/subpackages/hotel/chain-detail/main' : 'pages/home/main'
        }
        if (row.chainId) params['isBase64'] = 0
        const resp = (await API.omsAPI[this.env].clientServer.getMiniCode(params, {'x-ca-stage':this.headerENV,'token':this.token})).data
        this.qrcodeModal.rqcodeUrl = resp
      },
      closeQrcodetModal(){
        this.qrcodeModal.display = false
      },
      tariffReportTable(){},
      changePage(pageIndex) {
          this.listPage = pageIndex;
          this.sendQueryParams.page = pageIndex
          this.queryTariff();
      },
      changePageSize(pageSize){
        this.sendQueryParams.pageSize = pageSize
        this.queryTariff();
      },
      async queryTariff(){
         let qrcodeList = (await API.omsAPI[this.env].wechat.queryQrcodeList(this.sendQueryParams,this.token)).data
         this.listCount = qrcodeList.totalCount
         this.tariffList = qrcodeList || []
      },
      async queryProvincesList(){
        let ProvincesList = (await API.omsAPI[this.env].php.provincesList()).data
        // let ProvincesList = (await API.omsAPI[this.env].tool.getProvinces()).data
        this.provincesList =  ProvincesList || []
      },
      async changeProvice(id) { //获取城市列表
        let cityList = id ? (await API.omsAPI[this.env].php.cityList({id:id})).data : []
        // let cityList = id ? (await API.omsAPI[this.env].tool.getCities(id)).data : []
        this.cityList = cityList || [];
        return this.cityList
       },
      async delTariff(qrcodeId){
        const resp = (await API.omsAPI[this.env].wechat.deleteQrcodeDelete(qrcodeId, this.token)).data

        if(!resp){
          // 失败
          this.$Notice.error({
            title: "删除失败",
            desc: resp.msg
          });
        }else{
          this.$Notice.success({
            title: "删除成功",
          });
          this.queryTariff()
        }
      },
      async addModalOk(){
          let validResult = false

          this.$refs.editTariffModalForm.validate((valid) => {
            validResult = valid
            // console.info('validResult-----------------------',validResult)
          })

          if(!validResult){
            this.$refs.editTariffModal.buttonLoading = false
            return
          }
          if(this.editTariffModal.disabled){
              let cityName =  this.$refs.getCitySelete.query ? this.$refs.getCitySelete.query : this.editTariffModal.city;
              let proName =  this.$refs.getProSelete.query ? this.$refs.getProSelete.query : this.editTariffModal.province;
              let res = (await API.omsAPI[this.env].wechat.editQrcodeEdit(
                        cityName,
                        this.editTariffModal.cityId,
                        this.editTariffModal.cmsName,
                        this.editTariffModal.keyword,
                        this.editTariffModal.name,
                        proName,
                        this.editTariffModal.provinceId,
                        this.editTariffModal.id,
                        this.editTariffModal.state,
                        this.editTariffModal.sources,
                        this.token)
                        ).data
                        if (res.retCode) {
                          this.$refs.editTariffModal.buttonLoading = false
                          this.$Notice.error({
                            title:'编辑失败',
                            desc:res.msg
                          })
                        }else{
                          this.editTariffModal.display = false
                          this.queryTariff()
                          this.$Notice.success({
                            title:'编辑成功'
                          })
                        }
          }else{
            let res = (await API.omsAPI[this.env].wechat.addQrcodeCreate(
                        this.$refs.getCitySelete.query,
                        this.editTariffModal.cityId,
                        this.editTariffModal.cmsName,
                        this.editTariffModal.keyword,
                        this.editTariffModal.name,
                        this.$refs.getProSelete.query,
                        this.editTariffModal.provinceId,
                        this.editTariffModal.sources,
                        this.editTariffModal.state,
                        this.token)
                        ).data
                        if (res.retCode) {
                          this.$refs.editTariffModal.buttonLoading = false
                          this.$Notice.error({
                            title:'新增失败',
                            desc:res.msg
                          })
                        }else{
                          this.editTariffModal.display = false
                          this.queryTariff()
                          this.$Notice.success({
                            title:'新增成功'
                          })
                        }
          }

      },
      // async openEditChannelModal(params){
      //       this.editTariffModal.disabled = params.id ? true : false
      //       this.editTariffModal.qrId = params.id
      //       console.info('params------------',params)
      //       this.editTariffModal.province = params.provinceId
      //       this.editTariffModal.city = params.cityId
      //       this.editTariffModal.cmsName = params.cmsName
      //       this.editTariffModal.keyword = params.keyword
      //       this.editTariffModal.name = params.name
      //       this.editTariffModal.sources = params.sources
      //       this.editTariffModal.state = params.state + ''
      //       this.editTariffModal.display = true
      // },
      preventSubmit() {
        return false;
      }
  }
}
</script>

<style lang="scss" scoped>

</style>





// WEBPACK FOOTER //
// src/pages/wechat/tariff-list.vue